<template>
  <div class="alarmM" :class="alarmNum == 0 ? 'bgBlue' : 'bgRed'" @click="openWarningDialog">
    <img class="alarmLogo" :src="alarmLogo" alt="" />
    <span class="alarmNum"
      >预警数:<span>{{alarmNum == 0 ? "暂无" : alarmNum}}</span></span>
    <warningDialog :visible.sync="warningDialogVisible" :type="type" />
  </div>
</template>
<script>
import {
  getCurrentTime,
  getWarningList
} from "@/api/api";
import warningDialog from "@/components/warningDialog/warningDialog.vue";
import { mapState } from "vuex";
export default {
  components: {
    warningDialog
  },
  props: {
    type:''
  },
  data() {
    return {
      currentDate:'',
      currentTime:'',
      alarmNum: 0,
      alarmLogo: require("../assets/img/icon-alarm@2x.png"),
      warningDialogVisible: false
    };
  },
  created() {
    const timeMachine = getCurrentTime();
    this.currentDate = timeMachine.split(" ")[0];
    this.currentTime = timeMachine.split(" ")[1];
    this.dataRefreh();
  },
   beforeDestroy() {
    this.clear();
  },
  methods: {
    openWarningDialog() {
      this.warningDialogVisible = true;
    },
    // 定时刷新数据函数
    dataRefreh() {
      // 计时器正在进行中，退出函数
      if (this.intervalId != null) {
        return;
      }
      // 计时器为空，操作
      this.intervalId = setInterval(() => {
        this.getAlarm()
      }, 30000);
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId); //清除计时器
      this.intervalId = null; //设置为null
    },
    async getAlarm() {
      let req = {
        engineerId: this.engineerId,
        materialType: this.type,
        // sectionId: this.seIds,
        // workAreaId: this.sectionId,
        // endDate:'2026-7-3',
        // startDate: '2026-7-3'
        endDate: this.currentDate,
        startDate: this.currentDate
      }
      const alarmData =await getWarningList(req)
      this.alarmNum = alarmData.data.allCount
      if (this.alarmNum == 0) {
        this.alarmLogo = require("../assets/img/icon-alarm-nothing@2x.png");
      } else {
        this.alarmLogo = require("../assets/img/icon-alarm@2x.png");
      }
    }
  },
  computed: mapState(["engineerId", "sectionId","workAreaId","seIds"]),
  watch: {
    engineerId(curVal, oldVal) {
      
    },
    sectionId(curVal, oldVal) {
      if (!curVal || curVal === oldVal) return
      this.getAlarm()
    },
    workAreaId(curVal, oldVal) {}
  }
};
</script>

<style lang="less" scoped>
.alarmM {
  position: absolute;
  width: 100%;
  height: 30%;
  cursor: pointer;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .alarmLogo {
    margin-left: 38px;
    margin-right: 8px;
    margin-top: 4px;
    width: 26px;
    height: 26px;
  }
  .alarmNum {
    color: #fff;
    font-size: 17px;
    vertical-align: super;
    span {
      font-weight:700;
      margin-left:6px;
    }
  }
}
.bgRed {
  background-image: url(../assets/img/alarm-red@2x.png);
}
.bgBlue {
  background-image: url(../assets/img/alarm-blue@2x.png);
}
</style>



// WEBPACK FOOTER //
// src/subassembly/alarm.vue